<template>
    <modal @before-open="beforeOpen" @opened="opened" @before-close="beforeClose" name="serviceHandle"
           :draggable="'.header'" :reset="true"
           :classes="['serviceHandle','generalbox']" :adaptive="true" :height="'100%'" :width="'100%'"
           :min-width="1092" :min-height="614" :click-to-close="false">
      <div class="header">
        <h2>{{serviceInfo.name}}</h2>
        <div class="rating">
          <rating :score="serviceInfo.score"></rating>
        </div>
        <span class="stateBallContainer" v-if="serviceInfo.type===1 && serviceInfo.onlineSort==='online'">
      <state-ball ref="stateBall" :count="getServiceStateData"></state-ball>
      </span>
        <div @click="close" class="close">
          <i class="iconfont icon-cha"></i>
        </div>
      </div>
      <div class="content">
        <div class="nav">
          <ul class="navlist">
            <li v-if="item.isShow" @click="changeShowIndex(item.id)" v-for="item in navList"
                :class="{'on':item.id===currentShowIndex}">
              {{item.title}}
            </li>
          </ul>
          <div @click="toggleCollectStatus" class="collect" :class="{'on':serviceInfo.collection}">
            <i class="iconfont icon-shoucang"></i>
            收藏
          </div>
          <div class="collect qrcode-container">
            <i class="iconfont icon-saoma"></i>分享
            <div class="qrcode">
              <img :src="serviceInfo.plusinfo" alt="qr"/>
            </div>
          </div>

        </div>
        <div class="tabs-content serviceIntroduce" v-show="currentShowIndex===0 || currentShowIndex===1">
          <div class="right">
            <ul>
              <li>
                <p>开放对象：</p>
                <p>{{serviceGuide.open_user}}</p>
              </li>
              <li>
                <p>负责单位：</p>
                <p>{{serviceGuide.guide_resp_dept_name}}</p>
              </li>
              <li>
                <p>联系人：</p>
                <p>{{serviceGuide.link_man}}</p>
              </li>
              <li>
                <p>联系电话：</p>
                <p>{{serviceGuide.link_tel}}</p>
              </li>
              <li>
                <p>办理日期：</p>
                <p>{{serviceGuide.service_day}}</p>
              </li>
              <li>
                <p>办理时间：</p>
                <p>{{serviceGuide.service_time}}</p>
              </li>
              <li>
                <p>办理地点：</p>
                <p>{{serviceGuide.apply_address}} <span v-if="false"
                                                        @click="openMap(serviceGuide.longitude,serviceGuide.latitude,serviceGuide.apply_address)"
                                                        class="tomap"><i class="iconfont icon-ico_site"></i></span></p>
              </li>
              <li>
                <div class="map">

                </div>
              </li>
            </ul>
          </div>
          <div class="desc-content">
            <h2>注意事项</h2>
            <div v-html="serviceGuide.attention" class="guideContent"></div>
            <h2>附件下载</h2>
            <div class="guideContent fileList">
              <div @click="openNewTab(item)" v-for="item in serviceGuide.attaList" class="fileContainer">
                {{item.realName}}
              </div>
            </div>
            <h2>流程图</h2>
            <div class="guideContent imgList">
              <div @click="openNewTab(item)" v-for="item in serviceGuide.imgList" class="imgContainer">
                <img :src="item.storeName"/>
                <p>{{item.realName}}</p>
              </div>
            </div>
            <h2>流程说明</h2>
            <div v-html="serviceGuide.body" class="guideContent"></div>
          </div>
          <div class="toHandle">
            <button @click="toHandle">去办理</button>
          </div>
        </div>
        <!--<div class="tabs-content" v-show="currentShowIndex===1">在线咨询</div>-->

        <div class="tabs-content handleOnline" v-show="currentShowIndex===3">

          <div v-if="false" class="topbar">
            <div class="right">
              <ul>
                <li class="blue">提交</li>
                <li class="green">流程</li>
                <li class="pink">暂存</li>
                <li class="yellow">附件</li>
                <li class="red">重置</li>
              </ul>
            </div>
            <div class="info">
              <div class="infomain">
                <div class="title">
                  <span>标&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;题:</span>
                  <div class="input-container">
                    <input type="text"/>
                    <p>不能为空</p>
                  </div>

                </div>
                <div class="desc">
                  <span>固定流程:</span>
                  <div class="input-container">
                    <input type="text"/>
                    <p>不能为空</p>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div v-if="serviceInfo.appOpenType==='frame'" class="formarea">
            <iframe ref="extraPage" name="extraPage" class="formmain" :src="realFromUrl"
                    frameborder="0"></iframe>
          </div>

        </div>
        <div class="tabs-content service-commit" v-if="currentShowIndex===4">
          <h3 v-if="ratingList.length">评价内容</h3>
          <div>
            <ul v-if="ratingList.length" class="discuss-list">
              <li v-for="ratingItem in ratingList">
                <img class="avatar" :src="ratingItem.photo" alt=""/>
                <p>{{ratingItem.username}}说：</p>
                <div class="ratingContent" v-html="ratingItem.content"></div>
                <span>评论时间：{{ratingItem.time}}</span>
              </li>
            </ul>
            <div v-if="ratingList.length" class="pagination">
              <v-pagination @page-change="ratingPageChange" @page-size-change="ratingPageSizeChange"
                            :total="ratingTotalCount"
                            :pageIndex="ratingPageNumber" :page-size="ratingPageSize"
                            :pageSizeOption="[5,10,15]"></v-pagination>
            </div>
            <p class="createDiscussTitle">发布评论</p>
            <p class="setRatingTitle">为应用评分：</p>
            <rating-set ref="ratingSet"></rating-set>
            <div class="input-container">
              <!--<textarea width="100%"></textarea>-->
              <v-editor-app v-model="ratingContent"></v-editor-app>
              <span>1/100</span>
            </div>
            <button @click="ratingSubmit" class="submitBtn">提交评论</button>
          </div>
        </div>
        <div class="tabs-content serviceTodoContainer" v-if="currentShowIndex===5">
          <service-todo :serviceInfo="serviceInfo"></service-todo>
        </div>
        <bd-map></bd-map>
      </div>
    </modal>
</template>
<script>
  import orderCalendar from "components/order/orderCalendar"
  import serviceRating from "components/service/serviceRating"
  import rating from "components/globalComp/rating"
  import ratingSet from "components/globalComp/ratingSet"
  import stateBall from "components/service/stateBall"
  import orderAction from 'components/order/orderAction'
  //通信总线
  import Bus from 'common/js/bus.js'
  //地图
  import bdMap from "components/service/bdMapModal"
  //axios
  import axios from 'axios'
  import apiConfig from 'common/js/api_config'
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex'
  import store from 'store/index'
  import serviceTodo from 'components/service/serviceTodo'

  export default {
    name: "service_handle",
    data() {
      return {
        //服务ID
        serviceId: null,
        //服务详情
        serviceInfo: {},
        realFromUrl: null,
        fromLoaded: false,
        //指南ID
        guideId: null,
        //指南详情
        serviceGuide: {},
        navList: [],

        orderData: {},

        currentShowIndex: 0,
        floatBoxPOS: {x: 0, y: 0},
        floatBoxIsShow: false,
        calendarObj: null,
        floatBoxPayload: {
          time: "",
          status: "",
          freeCount: "",
          holdCount: "",
        },

        /***
         * 【服务评价】
         ***/
        ratingList: [],
        ratingPageNumber: 1,
        ratingPageSize: 5,
        ratingPageCount: null,
        ratingTotalCount: null,
        ratingContent: "",


        //当前服务在列表中的缓存数据
        currentServiceListStoreData: null,
        //当前正在预约的数据
        currentOrderHanleData: null,


      }
    },
    props: {
      isShow: {
        type: Boolean,
        default: true,
      }
    },
    mounted() {
      this.calendarObj = this.$refs.orderCalendar;
      let extraPage = this.$refs.extraPage;
      console.log("@#@@@@@@@>>>", extraPage)

    },
    methods: {
      ...mapMutations(['updateModalZIndex']),
      //前置数据处理
      beforeOpen(data) {
        Bus.$emit('toTop')
        this.currentServiceListStoreData = data.params
        //初始化navlist
        this.navList = [
          {
            //所有的都有
            title: "服务指南",
            id: 0,
            isShow: 1
          },
          {
            //应用系统
            title: "打开应用",
            id: 1,
            isShow: 0
          },
          {
            //线下流程有
            title: "在线预约",
            id: 2,
            isShow: 0
          },
          {
            //所有的都有
            title: "在线办理",
            id: 3,
            isShow: 1
          },
          {
            //所有的都有
            title: "服务评价",
            id: 4,
            isShow: 1
          },
          {
            //线上流程有
            title: "我的事项",
            id: 5,
            isShow: 0
          },
          {
            //所有的都没有
            title: "我的预约",
            id: 6,
            isShow: 0
          },

        ]
        this.currentShowIndex = 0

        this.guideId = parseInt(data.params.guideId);
        this.serviceId = data.params.appid;

        if (data.params.targetTab) {
          this.currentShowIndex = data.params.targetTab;
        }
        store.commit("toggleSideMenuShow", true);

        this.initServiceInfo()
        this.getGuideContent()
        this.initRatingInfo()
      },
      opened() {
        this.updateModalZIndex(this.$el)
      },
      //析构
      beforeClose() {
        this.fromLoaded = false;
        this.realFromUrl = "";
      },
      //请求服务基础信息
      async initServiceInfo() {
        let serviceData = await axios.post(apiConfig.REQUEST_URL + "/shall/f_getService?sysId=" + this.serviceId);
        if (!serviceData.data.status) {
          console.log("%请求服务详情错误：initServiceInfo", "font-size:50px;color:#f60");
          return
        }
        console.log(serviceData)
        serviceData = serviceData.data.data[0];
        this.serviceInfo = serviceData;

        switch (serviceData.type) {
          case 0:
            this.navList[3].title = '在线使用'
            break;
          case 1:
            if (serviceData.onlineSort === "online") {
              this.navList[5].isShow = 1;
            } else if (serviceData.onlineSort === "offline") {
              this.navList[3].isShow = 0;
            } else {
              this.navList[2].isShow = 1;
              this.navList[3].isShow = 0;
            }
            break;
          case 2:
            this.navList[1].isShow = 1;
            this.navList[3].isShow = 0;
            break;
          case 3:
            break;
          case 4:
            this.navList[3].title = '在线使用'
            break;
          default:
            console.log('initServiceInfo serviceData.type数据异常')
        }

        console.log(`${serviceData.name}权限状态：${serviceData.inPower} - type:${serviceData.type} - onlineSort:${serviceData.onlineSort}`)
        if (!serviceData.inPower) {
          for (let key in this.navList) {
            if (!(this.navList[key].id === 0 || this.navList[key].id === 4)) {
              this.navList[key].isShow = 0
            }
          }
        }
      },
      //请求指南
      async getGuideContent() {
        let guideData = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getGuideInfo?id=" +  this.guideId).catch((err) => {
          console.log("请求指南出错：", err);
        });
        if (!guideData.data.status) {
          console.log("%请求指南错误：getGuideContent", "font-size:50px;color:#f60");
          return;
        }
        guideData = guideData.data.data[0];
        this.serviceGuide = guideData
      },
      //请求评价
      async initRatingInfo() {
        let ratingInfo = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getEvaluateServiceList?" + this.$qs.stringify({
          sysId: this.serviceId,
          pageSize: this.ratingPageSize,
          pageNumber: this.ratingPageNumber,
          property: 'content',
          keyword: null
        }))
        if (ratingInfo.data.status) {
          ratingInfo = ratingInfo.data.data[0];
        }
        this.ratingList = ratingInfo.list;
        this.ratingPageNumber = ratingInfo.pageNumber;
        this.ratingPageSize = ratingInfo.pageSize;
        this.ratingPageCount = ratingInfo.pageCount;
        this.ratingTotalCount = ratingInfo.totalCount;

      },
      //提交评价
      async ratingSubmit() {
        let score = this.$refs.ratingSet.userSet;
        if (!this.ratingContent || this.ratingContent === "<p><br></p>") {
          this.$notify({
            group: "global",
            title: "温馨提示",
            text: "评价内容不能为空~",
          });
          return;
        }

        let resp = await axios.post(apiConfig.REQUEST_URL + "/shall/front_evaluateService?" + this.$qs.stringify({
          sysId: this.serviceId,
          content: this.ratingContent,
          score: score
        }));
        if (resp.data.status) {
          this.$notify({
            group: "global",
            title: "温馨提示",
            text: "评价提交成功~",
          });
          this.ratingContent = "";
          this.$refs.ratingSet.userSet = 0;
          this.initRatingInfo();
        }
      },

      changeShowIndex(id) {
        this.currentShowIndex = id;
      },

      //切换收藏状态
      async toggleCollectStatus() {
        this.serviceInfo.collection = !this.serviceInfo.collection;

        let resp = await axios.post(apiConfig.REQUEST_URL + "/shall/front_collectionService?" + this.$qs.stringify({
          sysId: this.serviceId,
          type: this.serviceInfo.collection ? 1 : 0
        }))
      },
      //=========【在线预约】=========
      monthOffset(way) {
        this.$refs.orderCalendar.monthOffset(way);
      },
      getStatusDesc(n) {
        let descText = "";
        switch (parseInt(n)) {
          case 0:
            descText = "不可预约";
            break;
          case 1:
            descText = "预约已满";
            break;
          case 2:
            descText = "可预约";
            break;
          case 3:
            descText = "预约过半";
            break;
          default:
            console.log("getStatusDesc参数异常");
        }
        return descText;
      },
      mouseenter(d) {
        this.floatBoxPayload.time = d.date.cusArr.join("-") + " " + d.step.desc;
        this.floatBoxPayload.freeCount = d.step.freeCount;
        this.floatBoxPayload.holdCount = d.step.holdCount;
        this.floatBoxPayload.status = this.getStatusDesc(d.step.status);
        this.floatBoxIsShow = true;

      },
      mousemove(d) {
        let x = d.event.pageX;
        let y = d.event.pageY;
        this.floatBoxPOS.x = x;
        this.floatBoxPOS.y = y;

      },
      mouseleave(d) {
        this.floatBoxIsShow = false;
      },
      toToday() {
        this.$refs.orderCalendar.toToday();
      },

      //日历切换
      calendarChange() {
        this.setOrderCalendarData()
      },
      //设置日期时段数据
      setDateStepData(origin, targetData) {
        origin.forEach((item, index) => {
          item.status = targetData[index].status;
          item.freeCount = targetData[index].freeCount;
          item.holdCount = targetData[index].holdCount;
        });
        return origin;
      },
      setOrderCalendarData() {
        this.$refs.orderCalendar.calendarData.forEach((row, index) => {
          row.forEach((col, colIdx) => {
            let targetData = this.orderData[col.cusArr.join("-")];
            if (targetData) {
              col.stepArr = this.setDateStepData(col.stepArr, targetData);
            }
          })
        });
      },
      /***
       * 订购流程
       * d.date 日期
       * d.step 时段
       * d.event 事件对象
       * @param d
       */
      async orderAction(d) {


        let status = d.step.status;
        if (!status || status === 1) {
          this.$notify({
            group: "global",
            title: "温馨提示",
            text: "当前时间不可预约",
          });
          return;
        }
        console.log(`执行预约操作：日期${d.date.cusArr.join("-")}，时段${d.step.desc}`);

        let anonAction = 1;
        if (d.step.status === 4) {
          anonAction = 0;
        }

        if (anonAction === 1) {
          this.currentOrderHanleData = {sysId: this.serviceId, day: d.date.cusArr.join('-'), type: (d.step.id - 1)}
          return
        }

        //取消预约

        let orderResult = await axios.post(apiConfig.REQUEST_URL + "/shall/front_order?" + this.$qs.stringify({
          sysId: this.serviceId,
          day: d.date.cusArr.join("-"),
          type: (d.step.id - 1),
          anon: anonAction
        }));

        if (orderResult.data.status) {
          this.$refs.orderCalendar.toToday();
        }
        this.$notify({
          group: "global",
          title: "温馨提示",
          text: orderResult.data.msg,
        });

      },
      //关闭
      close() {
        this.navList[2].isShow = 0;
        this.navList[3].isShow = 0;

        if (this.$route.path.indexOf("/home") !== -1) {
          store.commit("toggleSideMenuShow", false);
        }
        this.currentShowIndex = 0;
        this.$modal.hide("serviceHandle");
      },
      //展示大图
      openNewTab(item) {
        window.open(item.storeName)
      },
      //去办理
      toHandle() {
        this.currentShowIndex = 3;
      },
      //打开地图
      openMap(x, y, text) {
        this.$modal.show("bdMap", {posX: x, posY: y, text});
      },
      //######评价相关的############
      ratingPageChange(pageIndex) {
        this.ratingPageNumber = pageIndex;
        this.initRatingInfo();
      },
      ratingPageSizeChange(newPageSize) {
        this.ratingPageNumber = 1;
        this.ratingPageSize = newPageSize;
        this.initRatingInfo();
      },
      //请求数据
      async borderDateOffset(data) {

        let orderInfo = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getOrderInfo?" + this.$qs.stringify({
          sysId: this.serviceId,
          starttime: data.headDate,
          daynum: data.dateCount
        }));
        if (!orderInfo.data.data.length) {
          return;
        }
        orderInfo = orderInfo.data.data[0];

        this.orderData = orderInfo;
        this.setOrderCalendarData()


      },
      closeOrderAction() {
        this.currentOrderHanleData = null
      },
      orderFinish() {
        this.closeOrderAction()
        this.$refs.orderCalendar.toToday();
      },

    },
    watch: {
      currentShowIndex(newVal, oldVal) {
        if (newVal !== 0) {
          if (!this.$store.getters.getUserLoginStatus) {
            console.log("需要登录,当前没有登录")
            this.currentShowIndex = 0;
            this.$notify({
              group: "global",
              title: "温馨提示",
              text: "登录后才能进行下一步操作！"
            });

            //生成跳转数据
            let userActionData = {
              type: "serviceHandle",
              serviceId: this.serviceId,
              guideId: this.guideId,
              targetTab: newVal
            };
            let userActionDataStr = JSON.stringify(userActionData);
            userActionDataStr = userActionDataStr.replace(/{/g, '(')
            userActionDataStr = userActionDataStr.replace(/}/g, ')')
            location.replace(apiConfig.REQUEST_URL + "/shall/users?info=" + this.$route.path + `?loginData=${userActionDataStr}`);
          }
        }
        if (this.currentShowIndex === 1) {
          window.open(this.serviceInfo.pc_url)
        }
        //在线办理
        if (newVal === 3) {
          if (this.serviceInfo.appOpenType !== 'frame') {
            this.currentShowIndex = 0
            window.open(this.serviceInfo.pc_url)
            return
          }
          if (this.fromLoaded) {
            return;
          }
          this.realFromUrl = this.serviceInfo.pc_url;
          this.fromLoaded = true;
        }
      }
    },
    filters: {
      //获取默认评分
      defaultScore(val) {
        if (!parseInt(val)) {
          return 3.5;
        }
        return val;
      },

    },
    computed: {
      floatBoxStyle() {
        let offsetDistance = 10;
        let display = this.floatBoxIsShow ? "block" : "none";
        return `left:${this.floatBoxPOS.x + offsetDistance}px;top:${this.floatBoxPOS.y + offsetDistance}px;display:${display}`;
      },
      getServiceStateData() {
        return {
          finishNum: this.currentServiceListStoreData.finishNum,
          myApplyNum: this.currentServiceListStoreData.myApplyNum,
          runingNum: this.currentServiceListStoreData.runingNum
        }
      }
    },
    components: {orderCalendar, rating, serviceRating, ratingSet, stateBall, bdMap, orderAction, serviceTodo}
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .serviceHandle
    .content
      overflow-y hidden

  .header
    width 100%
    .rating
      display inline-block

    & >>> .status-desc
      display inline-block
      float none
      margin-top 0
      margin-left 10px

  .content
    color #333333
    overflow-y scroll !important
    height calc(100% - 50px)
    position relative

    .nav
      height 50px
      line-height 50px
      border-bottom 1px solid #f6f6f6
      box-shadow 0 2px 3px #cccccc

      &::after
        content ""
        display block
        width 100%
        clear both

      .navlist
        margin-left 35px
        float left
        /*border 1px solid #f99*/
        /*border 1px solid #f60*/

        li
          display inline-block
          width 77px
          height 23px
          text-align center
          line-height 23px
          font-size 14px
          color #999999
          border-radius 11px
          margin-right 15px
          cursor pointer
          user-select none
          transition 300ms

          &:hover
            background-color #eeeeee

          &.on
            background-color #004a94
            color #ffffff

      .collect
        margin-right 26px
        color #999999
        font-size 12px
        float right
        cursor pointer
        transition 300ms
        user-select none

        &:hover
          color #666666

        i
          margin-right 2px

        &.on i
          color #2671b0

      .qrcode-container
        position relative

        &:hover
          .qrcode
            display block

        i
          font-size 18px
          margin-right 6px !important
          vertical-align middle
          line-height 55px

        .qrcode
          display none
          position absolute
          left -56px
          top 85%
          z-index 8
          background-color #ffffff
          border 1px solid #cccccc
          box-shadow 2px 2px 3px #cccccc
          width 150px
          height 150px
          padding 10px

          img
            width 100%
            height 100%

    .tabs-content
      padding 30px 50px
      padding-right 0
      width 100%
      position absolute
      top 105px
      bottom 0

      &.serviceTodoContainer
        padding 0

    .serviceIntroduce
      .right
        float right
        width 263px

        ul
          width 222px
          margin auto

          li
            padding 12px
            border-bottom 1px solid #e9eaec

            &:last-of-type
              border-bottom none

            p
              font-size 14px
              color #666666
              line-height 26px

              .tomap
                cursor pointer
                color #004a94
                transition 300ms

                &:hover
                  color #0062c3

      .desc-content
        height 100%
        overflow-y scroll

        & > h2
          border-left 3px solid #004a94
          margin-bottom 15px
          margin-top 15px
          padding-left 8px

        & > .guideContent
          font-size 14px
          color #666666
          padding-left 10px

        & > .imgList
          .imgContainer
            margin-right 15px
            margin-top 10px
            display inline-block
            padding 10px
            transition 300ms
            border-radius 6px

            &:hover
              background-color #eeeeee

            img
              max-width 100%
              cursor pointer

            p
              display none
              margin-top 10px
              line-height 30px
              text-align center

        & > .fileList
          .fileContainer
            border-radius 6px
            font-size 14px
            color #666666
            line-height 40px
            padding-left 10px
            transition 300ms
            cursor pointer

            &:hover
              background-color #eeeeee

      .toHandle
        display none
        width 100%
        height 60px
        text-align center
        position absolute
        bottom 0

        button
          width 160px
          height 50px
          color #439138
          font-size 18px
          border 1px solid #439138
          border-radius 10px
          background #ffffff
          outline none
          transition 300ms

          &:hover
            background rgba(67, 145, 56, 0.8)
            color #ffffff

    .orderOnline
      padding-right 50px

      .orderinfo
        margin-bottom 20px

        &::after
          content ""
          display block
          width 100%
          clear both

        .avatar
          width 60px
          height 60px
          margin-right 10px
          float left

        & > h3
          font-size 20px
          line-height 30px
          color #333333

        & > p
          float left
          line-height 35px
          margin-right 20px
          font-size 14px
          color #999999

        & > ul
          float right
          margin-top -20px

          li
            display inline-block
            width 58px
            height 25px
            background-color #3E50B4
            font-size 12px
            line-height 25px
            text-align center
            color #ffffff
            border-radius 12px
            cursor pointer
            user-select none

            &:nth-of-type(2)
              background-color #16A61E

      .floatBox
        width 272px
        height 110px
        border 1px solid #c8ba92
        z-index 999
        position fixed
        overflow hidden

        h4
          border-bottom 1px solid #c8ba92
          background-color #f3f0e7
          font-size 14px
          padding-left 1em
          color #333333
          height 33px
          line-height 33px
          font-weight bold

        div
          background-color #ffffff
          font-size 14px
          color #666666
          height 78px
          padding 0.5em 1em
          line-height 20px

      .desc
        float right

        p
          font-size 12px
          padding-left 20px
          line-height 26px
          color #666

          & > span
            width 20px
            height 20px
            display inline-block
            vertical-align middle
            margin-bottom 3px
            margin-right 10px

          .grey
            background-color #e6e6e6

          .blue
            background-color #299bdf

          .yellow
            background-color #ffd700

          .red
            background-color #f96262

          .green
            color #ffffff
            text-align center
            line-height 22px
            background-color #16a61e

      //在线预约

      .orderCalendar
        overflow hidden

        & >>> .calendar
          .row
            height 60px

            .col
              line-height 30px
              border 1px solid #e1e1e8
              /*border-bottom none*/
              background-color #ffffff
              position relative

              &.today
                background-color #005ab3
                color #ffffff
                font-weight bold

              &::after
                display block
                content ""
                right 0
                top 0
                bottom 0
                position absolute
                border-right 3px solid #005ab3

              &.weekItem ul li::after
                display none

              ul
                width 100%
                height 28px

                li
                  height 100%
                  width 33%
                  float left
                  position relative
                  background-color #ffffff
                  border 1px solid #e6e6e6
                  border-bottom none

                  &.no::after
                    background-color #e6e6e6
                    cursor not-allowed

                  &.full::after
                    background-color #f96262
                    cursor not-allowed

                  &.can::after
                    background-color #299bdf
                    cursor pointer

                  &.half::after
                    background-color #ffd700
                    cursor pointer

                  &.ordered::after
                    background-color #16a61e
                    cursor pointer

                  &::after
                    content ""
                    left 0
                    right 0
                    top 0
                    bottom 0
                    margin auto
                    display inline-block
                    width 20px
                    height 20px
                    position absolute

                  .iconfont
                    position relative
                    color #ffffff
                    display block
                    font-size 16px
                    z-index 9

    .handleOnline
      width 100%
      padding 10px
      position static

      .topbar
        margin 0 10px
        padding 10px
        box-shadow 2px 2px 2px #cccccc

        .right
          width 270px
          float right

          ul
            width 100%
            margin-top 5px

            li
              width 20%
              height 26px
              line-height 26px
              float left
              border-left 3px solid #ffffff
              border-right 3px solid #ffffff
              border-radius 5px
              font-size 12px
              color #ffffff
              background-color #f60
              text-align center
              cursor pointer

            .blue
              background-color #007aff

            .green
              background-color #3c8c01

            .pink
              background-color #a78adc

            .yellow
              background-color #d08d00

            .red
              background-color #d05252

        .info
          .infomain
            text-align left
            overflow hidden

            & > div
              height 38px

              & > span
                display inline-block
                line-height 38px
                width 105px
                text-align center
                font-size 14px
                color #666666

              & > .input-container
                height 26px
                display inline-block
                width calc(100% - 120px)
                border 1px solid #dddddd
                border-radius 5px
                font-size 14px
                color #666666
                padding 0 0.5em
                line-height 26px
                position relative

                & > p
                  display inline-block
                  position absolute
                  right 5px
                  top 0
                  bottom 0
                  line-height 26px
                  font-size 12px
                  color #d05252

                input
                  width 100%

      .formarea
        /*border 1px solid #0f0*/
        margin-top 40px
        position absolute
        left 0
        right 0
        top 60px
        bottom 0

        .formmain
          width 100%
          height 100%


    .service-commit
      padding-right 50px
      overflow-y scroll
      width 100%
      //max-height 780px

      h3
        font-weight bold
        color #333
        font-size 16px
        margin-bottom 8px

      div
        .discuss-list
          border 1px solid #edeeef
          background-color #f5f7f9
          border-radius 5px

          li
            padding 12px
            padding-bottom 0
            position relative

            &::after
              content ""
              width 100%
              height 1px
              background-color #c2c2c2
              margin auto
              margin-bottom 5px
              display block
              clear both

            &:last-of-type::after
              background-color #f5f7f9

            .avatar
              width 32px
              height 32px
              float left
              margin 12px 8px

            & > p
              font-size 16px
              margin-top 10px
              color #333333
              display block
              overflow hidden
              margin-bottom 5px

            & > .ratingContent
              margin-top 5px
              /*font-size 12px*/
              color #666666
              overflow hidden

            span
              font-size 14px
              color #333333
              margin-right 9px
              margin-bottom 5px
              float right

      .btnlist
        margin-top 30px
        text-align center
        user-select none

        button
          padding 6px
          font-size 12px
          color #333333
          background none
          outline none
          border-radius 5px
          display inline-block
          border 1px solid #f1f1f1
          transition 300ms

          &:hover
            background-color #eeeeee

          &.home
            color #1e5498
            border 1px solid #1e5498

          &.on
            color #ffffff
            background-color #1e5498

        p
          display inline-block
          font-size 14px
          margin-left 12px

          span
            color #1e5498

      .createDiscussTitle
        font-size 14px
        color #333333
        margin 25px 0 10px

      .setRatingTitle
        display inline-block
        line-height 20px
        vertical-align top
        margin-bottom 10px
        font-size 14px
        color #333333

      .input-container
        width 100%
        /*height 100px*/
        border-radius 10px
        border 1px solid #cacaca
        overflow hidden
        position relative

        textarea
          padding 1em
          border none
          outline none
          height 100%
          width 100%

        span
          font-size 12px
          position absolute
          right 8px
          bottom 22px
          user-select none
          color #cacaca

      .submitBtn
        width 92px
        height 35px
        background-color #1e5498
        border none
        border-radius 5px
        margin-top 20px
        outline none
        font-size 14px
        color #ffffff
        user-select none
        transition 300ms

        &:hover
          background-color #2668ad
</style>



// WEBPACK FOOTER //
// src/components/service/serviceHandleModal.vue